module.exports = __webpack_public_path__ + "static/media/institution-accent-light.cc9410c6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/institution-accent-light.svg
// module id = 644
// module chunks = 0